import React, { useRef, useEffect } from "react";
import {
  I2cCheckboxGroup,
  I2cListItem,
  I2cIcon,
  I2cCheckbox,I2cTooltip
} from "@webcomponents/i2cwebcomponents/dist/react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import cholderWebsite from "../../../assets/images/cholderwebsite.svg";
import androidIcon from "../../../assets/images/androidicon.svg";
import appleIcon from "../../../assets/images/appleicon.svg";

const AppSelectionForProgram = ({
  type,
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const app_Selection_Programs = [
    {
      label: "C-Holder Website",
      value: "C-Holder Website",
      icon: cholderWebsite,
    },
    {
      label: "Android App",
      value: "Android App",
      icon: androidIcon,
    },
    {
      label: "iOS App",
      value: "iOS App",
      icon: appleIcon,
    }
  ];

  const handleNetworkCheckboxGroupChange = (event) => {
    let SelectedNetworkValue;
    SelectedNetworkValue = event;
    let updatedSelectedNetworks = [
      ...(methods.getValues("app_selection_for_program") ?? []),
    ];
    if (updatedSelectedNetworks.includes(SelectedNetworkValue)) {
      updatedSelectedNetworks = updatedSelectedNetworks.filter(
        (card) => card !== SelectedNetworkValue,
      );
    } else {
      updatedSelectedNetworks.push(SelectedNetworkValue);
    }
    methods.setValue("app_selection_for_program", updatedSelectedNetworks);
    methods.trigger();
    handleValueChanges();
  };

  const generalErrorMessage = "Field is required";
  const validationSchema = Yup.object({
    app_selection_for_program: Yup.array(Yup.string())
      .required(generalErrorMessage)
      .min(1, "At least one app must be selected"),
  });

  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "all",
    shouldUseNativeValidation: false,
    criteriaMode: "all",
    defaultValues: {
      app_selection_for_program: [],
    },
  });
  const fields = [
    "app_selection_for_program",
  ];

  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[1]["1_0"][field] ?? "");
      });
      methods.trigger();
      handleValueChanges();
    }
  }, [isFetching]);
  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      1: {
        ...addFormData["1"],
        "1_0": { ...values },
      },
    });
  };


  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors)?.length;
    if (errorsLength === 0) setFormValidStates("1_0", true);
    else setFormValidStates("1_0", false);
  }, [Object.keys(errors)?.length]);
 
  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div slot="label" className="organize-tooltip mb-12">
              <div className="custom-label">
                Please indicate if you want to select i2c C-HolderWeb, C-Holder Mobile, or both for your program.
              </div>
              <I2cTooltip
                content="Please make sure that the selection reflects the selections made on the instance or program setup CSDs. If you have any questions, please contact your i2c Account Manager."
                placement="right-start"
              >
                <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
              </I2cTooltip>
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="app_selection_for_program"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cCheckboxGroup
                      {...field}
                      className="centeredCheckbox checkbox-margin"
                    >
                      <div i2c-grid="grid gap-sm">
                        {app_Selection_Programs.map((card, index) => (
                          <I2cListItem
                            key={index}
                            i2c-grid="4@md"
                            variant="receipt"
                            label={card.label}
                            sublabel=""
                            value=""
                            type="checkbox"
                            checked={methods
                              .watch("app_selection_for_program")
                              .includes(card.value)}
                            onI2cCheckboxClicked={(e) => {
                              handleNetworkCheckboxGroupChange(card.value);
                            }}
                          >
                            <I2cIcon
                              className="cholder-box-icons"
                              slot="prefix"
                              src={card.icon}
                              label="icon"
                            ></I2cIcon>
                            <I2cCheckbox
                              slot="checkbox"
                              name="app_selection_for_program"
                              filled
                              value={card.value}
                              label=""
                              ignoreTab
                              checked={methods
                                .watch("app_selection_for_program")
                                .includes(card.value)}
                         
                              className="customCheckbox"
                            ></I2cCheckbox>
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cCheckboxGroup>
                    <ErrorMessage
                      show={
                        errors.app_selection_for_program &&
                          methods.formState.touchedFields.app_selection_for_program
                          ? true
                          : false
                      }
                      message={
                        errors.app_selection_for_program?.message ?? "Invalid input"
                      }
                    />
                  </>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AppSelectionForProgram;
